module.exports = __webpack_public_path__ + "img/account.rate.daily.e77d2b3f.png";